import logo from '@assets/component/Header/logo.svg';

export const Logo = () => {
    return <img src={logo} width={180} />;
};
